/**
 * 获取title
 */
export function getClientTitle1(_self,func) {
  let title = localStorage.getItem('clientTitle')
  if (title != null) {
    if(title != 'null' && title != '') {
      func(title)
      document.title = title
      return title
    }
  }
  _self.axios.get(
    _self.api.getClientTitle,
  ).then(res => {
    if (res.data.code === 10000 && res.data.message != null && res.data.message !== undefined) {
      localStorage.setItem('clientTitle', res.data.message)
      func(res.data.message)
      document.title = res.data.message
    } else {
      localStorage.setItem('clientTitle', '')
      console.error('获取网站标题失败')
    }
  }).catch(err => {
    this.$message.error('网络请求异常!')
  })
}

/**
 * 存放cookie
 * @param key
 * @param value
 * @param expire 毫秒
 */
export function setExpire(key, value, expire) {
  const obj = {
    data: value,
    time: Date.now(),
    expire: expire
  }
  // localStorage 设置的值不能为对象,转为json字符串
  localStorage.setItem(key, JSON.stringify(obj))
}

/**
 * 获取数据
 * @param key
 * @return {*}
 */
export function getExpire(key) {
  let val = localStorage.getItem(key)
  if (!val) {
    return val
  }
  val = JSON.parse(val)
  if (Date.now() - val.time > val.expire) {
    localStorage.removeItem(key)
    return null
  }
  return val.data
}

/**
 * 加密密码
 * @param data 字符串
 * @param key 秘钥
 * @returns {string}
 */
export function encryption(data, key) {
  let crypto = require('crypto');
  var iv = "";
  var cipherChunks = [];
  var cipher = crypto.createCipheriv('aes-128-ecb', key, iv);
  cipher.setAutoPadding(true);
  cipherChunks.push(cipher.update(data, 'utf8', 'hex'));
  cipherChunks.push(cipher.final('hex'));
  return cipherChunks.join('').toUpperCase();
}




// WEBPACK FOOTER //
// ./src/assets/js/utils.js